import { Title } from "src/shared/Title";

export const NoSubscriptionsSlice = () => {
  return <Title type="h2">You don't have any subscriptions</Title>;
};
